import { useEffect, useMemo, useState } from 'react'

const SLA_MS = 5 * 60 * 1000

function formatMMSS(ms: number) {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000))
  const m = Math.floor(totalSeconds / 60)
  const s = totalSeconds % 60
  return `${m}:${s.toString().padStart(2, '0')}`
}

export function useSlaTimer(requestedAtIso: string) {
  const requestedAtMs = useMemo(() => new Date(requestedAtIso).getTime(), [requestedAtIso])

  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(t)
  }, [])

  const elapsed = now - requestedAtMs
  const remaining = SLA_MS - elapsed

  return {
    remainingMs: remaining,
    remainingText: formatMMSS(remaining),
    isExpired: remaining <= 0,
    isCritical: remaining > 0 && remaining <= 60_000, // last 1 minute
  }
}